import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

const styles = {
  errorMessage: {
    color: "red",
    alignText: "center"
  }
};

const EasyErrorMessage = props => {
  const errorState = props.connectForm.getFormErrorState();
  const { classes } = props;
  return (
    <Grid container justify="center">
      {errorState.errorMissingRequired ? (
        <Grid item xs={12}>
          <h4 className={classes.errorMessage}>Missing mandatory fields.</h4>
        </Grid>
      ) : null}
      {errorState.errorInvalid ? (
        <Grid item xs={12}>
          <h4 className={classes.errorMessage}>
            Some inputs have invalid format.
          </h4>
        </Grid>
      ) : null}
      {errorState.errorMessage !== "" ? (
        <Grid item xs={12}>
          <h4 className={classes.errorMessage}>{errorState.errorMessage}</h4>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default withStyles(styles)(EasyErrorMessage);
